module.exports = __webpack_public_path__ + "static/media/microsoft_logo.74ba64fe.png";